import type { ReactNode } from "react";

export interface RuleProps {
  children?: ReactNode;
  mono?: boolean;
  className?: string;
}

export function Rule({ children, mono = true, className = "" }: RuleProps) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {children && (
        <span className={`shrink-0 ${mono ? "eyebrow" : "label"}`}>{children}</span>
      )}
      <div className="flex-1 border-t border-[var(--rule)]" />
    </div>
  );
}
